"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdApollo = require("cccisd-apollo");
var _reportVariables = _interopRequireDefault(require("./reportVariables.graphql"));
var _server = _interopRequireDefault(require("react-dom/server"));
var _getMappingValues = _interopRequireDefault(require("./getMappingValues"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var DownloadText = function DownloadText(props) {
  var renderTrigger = props.renderTrigger,
    assignment = props.assignment,
    surveyHandles = props.surveyHandles,
    typeFilter = props.typeFilter,
    filter = props.filter,
    limit = props.limit,
    convertLoadedData = props.convertLoadedData;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var getData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var response, responseData;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            setLoading(true);
            _context.n = 1;
            return _cccisdApollo.client.query({
              query: _reportVariables["default"],
              variables: {
                assignmentId: [assignment.assignmentId],
                surveyHandle: surveyHandles,
                typeFilter: typeFilter,
                filter: filter,
                limit: limit,
                groupId: [assignment.groupId]
              },
              fetchPolicy: 'network-only'
            });
          case 1:
            response = _context.v;
            responseData = typeof convertLoadedData === 'function' ? convertLoadedData(response.data) : response.data;
            setLoading(false);
            return _context.a(2, responseData);
        }
      }, _callee);
    }));
    return function getData() {
      return _ref.apply(this, arguments);
    };
  }();
  var getCsvColumns = function getCsvColumns() {
    return [{
      label: 'Question'
    }, {
      label: 'Element Type'
    }, {
      label: 'Metric'
    }, {
      label: 'Variable'
    }, {
      label: 'Label'
    }, {
      label: 'Response Values'
    }, {
      label: 'Metric Type'
    }, {
      label: 'Identifiable'
    }, {
      label: 'Survey'
    }];
  };
  var getCSVRows = function getCSVRows(data) {
    // we need to insert this BOM character at the beginning of the csv file
    // that Excel will recognize it as a UTF-8 encoded file
    var universalBOM = "\uFEFF";
    var columns = getCsvColumns();
    var header = columns.map(function (column) {
      return prepareCsv(column.label);
    }).join(',') + '\n';
    var content = data.metrics.variableList.map(function (row) {
      return [prepareCsv(row.key.title), prepareCsv(row.key.entity.type), prepareCsv(row.key.metric), prepareCsv(row.reportHeader), prepareCsv(row.label), prepareCsv(responseValues(row)), prepareCsv(type(row)), prepareCsv(identifiable(row)), prepareCsv(survey(row))].join(',');
    }).join('\n') + '\n';
    return universalBOM + header + content;
  };
  var prepareCsv = function prepareCsv(value) {
    if (!value && value !== 0) {
      return '';
    }
    var stringValue = '';
    try {
      stringValue = /*#__PURE__*/_react["default"].isValidElement(value) ? _server["default"].renderToStaticMarkup(value) : String(value);
    } catch (error) {
      return '';
    }

    // strip HTML tags
    stringValue = stringValue.replace(/(<([^>]+)>)/gi, '');
    return /^[A-Za-z0-9._-]+$/.test(stringValue) ? stringValue : '"' + stringValue.replace(/"/g, '""') + '"';
  };
  var responseValues = function responseValues(row) {
    if (row.type === 'formula') {
      return null;
    }
    if (!row.isCodable) {
      return [row.key.content.minimum ? "Min: ".concat(row.key.content.minimum) : '', row.key.content.maximum ? "Max: ".concat(row.key.content.maximum) : ''].filter(function (item) {
        return item;
      }).join('\n');
    }
    return (0, _getMappingValues["default"])(row).map(function (item) {
      return item.code !== item.label ? "".concat(item.code, " - ").concat(item.label) : item.label;
    }).filter(function (item) {
      return item;
    }).join('\n');
  };
  var type = function type(row) {
    return row.type.split('_').map(function (t) {
      return t.charAt(0).toUpperCase() + t.slice(1);
    }).join(' ');
  };
  var identifiable = function identifiable(row) {
    return row.key.isIdentifying ? 'TRUE' : '';
  };
  var survey = function survey(row) {
    var surveysInList = [];
    row.key.surveyList.forEach(function (surveyItem) {
      if (!surveysInList.includes(surveyItem.label)) {
        surveysInList.push(surveyItem.label);
      }
    });
    return surveysInList.map(function (item) {
      return "".concat(item, " - ").concat(row.key.flow.language);
    }).join('\n');
  };
  var download = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var data, questProject, assignmentLabel, combinedName, fileName, text, element;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return getData();
          case 1:
            data = _context2.v;
            if (data) {
              questProject = data.groups.questproject.group.label;
              assignmentLabel = data.flows.assignment.label;
              combinedName = (questProject + ' ' + assignmentLabel).replace(/[\W]+/g, '_');
              fileName = combinedName + '.csv';
              text = getCSVRows(data);
              element = document.createElement('a');
              element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
              element.setAttribute('download', fileName);
              element.style.display = 'none';
              document.body.appendChild(element);
              element.click();
              document.body.removeChild(element);
            }
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function download() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
    loading: loading
  }, renderTrigger(download));
};
var _default = exports["default"] = DownloadText;